// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const SubmissionLimits = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.submissionQuota.submissionLimits"
        description="Submission limits."
        defaultMessage="Submission limits"
    />
);
SubmissionLimits.displayName = "SubmissionLimits";

export const AboutSubmissionLimits = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.submissionQuota.aboutSubmissionLimits"
        description="About submission limits."
        defaultMessage="About submission limits"
    />
);
AboutSubmissionLimits.displayName = "AboutSubmissionLimits";

export const NonLensPlus = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.submissionQuota.nonLensPlus"
        description="Non lens plus."
        defaultMessage="Non-Lens+"
    />
);
NonLensPlus.displayName = "NonLensPlus";

export const LensPlus = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.submissionQuota.lensPlus"
        description="Lens plus."
        defaultMessage="Lens+"
    />
);
LensPlus.displayName = "LensPlus";

export const Remaining = (props: { remaining: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.submissionQuota.remaining"
        description="Remaining."
        defaultMessage="{remaining} left"
        values={props}
    />
);
Remaining.displayName = "Remaining";

export const RunningLow = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.submissionQuota.runningLow"
        description="Running low."
        defaultMessage="Running low"
    />
);
RunningLow.displayName = "RunningLow";

export const AlmostUsed = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.submissionQuota.almostUsed"
        description="Almost used."
        defaultMessage="Almost used"
    />
);
AlmostUsed.displayName = "AlmostUsed";

export const LimitReached = (): ReactElement => (
    <FormattedMessage
        id="apps.layout.components.submissionQuota.limitReached"
        description="Limit reached."
        defaultMessage="Limit reached"
    />
);
LimitReached.displayName = "LimitReached";
